// Profile.js
import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import './Profile.css';

const Profile = () => {
  const [profile, setProfile] = useState({
    username: '',
    contactNumber: '',
    alternateContact: '',
    address: '',
    famousPlace: '',
    location: '',
  });

  const auth = getAuth();
  const userId = auth.currentUser ? auth.currentUser.uid : null;

  useEffect(() => {
    const fetchProfile = async () => {
      if (userId) {
        const profileRef = doc(db, `users/${userId}/profile/profileData`);
        const docSnap = await getDoc(profileRef);
        if (docSnap.exists()) {
          setProfile(docSnap.data());
        }
      }
    };
    fetchProfile();
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const updateProfile = async () => {
    if (userId) {
      const profileRef = doc(db, `users/${userId}/profile/profileData`);
      await setDoc(profileRef, profile, { merge: true });
      alert('Profile updated successfully!');
    }
  };

  return (
    <div className="profile-container-x">
      <h1>User Profile</h1>
      <div className="field-row-x">
        <label>Username:</label>
        <input 
          type="text" 
          name="username" 
          value={profile.username} 
          onChange={handleChange} 
          required 
        />
      </div>
      <div className="field-row-x">
        <label>Contact Number:</label>
        <input 
          type="text" 
          name="contactNumber" 
          value={profile.contactNumber} 
          onChange={handleChange} 
          required 
        />
      </div>
      <div className="field-row-x">
        <label>Alternate Contact:</label>
        <input 
          type="text" 
          name="alternateContact" 
          value={profile.alternateContact} 
          onChange={handleChange} 
        />
      </div>
      <div className="field-row-x">
        <label>Address:</label>
        <input 
          type="text" 
          name="address" 
          value={profile.address} 
          onChange={handleChange} 
        />
      </div>
      <div className="field-row-x">
        <label>Famous Nearby Place:</label>
        <input 
          type="text" 
          name="famousPlace" 
          value={profile.famousPlace} 
          onChange={handleChange} 
        />
      </div>
      <div className="field-row-x">
        <label>Location:</label>
        <input 
          type="text" 
          name="location" 
          value={profile.location} 
          onChange={handleChange} 
          required 
        />
      </div>
      <button onClick={updateProfile}><i class="fa-solid fa-upload"></i> Update Profile</button>
    </div>
);
}

export default Profile;
